import React from "react";
import { HTMLMotionProps, motion } from "framer-motion";

import { createAdvancedStore } from "@/stores/createAdvancedStore";

import { UseTabsReturn } from "./useTabs";

//

const tabsStore = createAdvancedStore<UseTabsReturn>("TabsStore");
export const useTabsContext = tabsStore.useContext;

//

export interface TabsProps {
  children?: React.ReactNode;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  tabsModel: UseTabsReturn<any>;
  animate?: boolean | (Omit<HTMLMotionProps<"div">, "ref"> & React.RefAttributes<HTMLDivElement>);
}

export const Tabs: React.FC<TabsProps> = ({ children, tabsModel, animate }) => {
  return (
    <tabsStore.Provider value={tabsModel}>
      {!animate ? (
        children
      ) : (
        <motion.div
          key={tabsModel.tab.id.toString()}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
          {...(typeof animate === "boolean" ? {} : animate)}
        >
          {children}
        </motion.div>
      )}
    </tabsStore.Provider>
  );
};
